import { render, staticRenderFns } from "./nurse.vue?vue&type=template&id=29bdd22e&scoped=true"
import script from "./nurse.vue?vue&type=script&lang=js"
export * from "./nurse.vue?vue&type=script&lang=js"
import style0 from "./nurse.vue?vue&type=style&index=0&id=29bdd22e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bdd22e",
  null
  
)

export default component.exports